<div class="m-4">
  <form (ngSubmit)="companyDetailsFormSub()" #f="ngForm">
    <div class="row" class="font-weight-bold mb-4">
      Enter Company Details
    </div>
    <div class="row">
      <div class="col-2 p-0">
        <label>Upload Company Logo</label>
        <p-fileUpload [disabled]="disableFields" #createUploader name="demo[]" mode="basic" chooseLabel="Browse"
          [auto]="true" customUpload="true" (uploadHandler)="onUpload($event, createUploader)" accept="image/*"
          invalidFileTypeMessageSummary=""
          invalidFileTypeMessageDetail="Unaccepted format. Please upload a 'png' format file" showUploadButton="false"
          showCancelButton="false" maxFileSize="10485760">
        </p-fileUpload>
      </div>

      <div class="col-10">
        <div style="width:20rem;height:auto">
          <img *ngIf="companyLogoImage" [src]="companyLogoImage" />
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0 ">
        <label class="required">Company/Organization Name</label>
        <input type="text" pInputText [disabled]="disableFields" class="im-input" name="companyName"
          [(ngModel)]="company.companyName" placeholder="Company name" #companyName="ngModel" required />
        <span class="invalid-message" *ngIf="
                  (companyName.touched || f.submitted) && companyName.errors?.required
                ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4">
        <label class="required">Business Type</label>
        <p-multiSelect [disabled]="disableFields" styleClass="w-100" #businessType="ngModel" name="businessType"
          required (onChange)="onBusinessTypeChange($event.value)" [options]="businessTypeList"
          [(ngModel)]="company.businessType" optionLabel="name">
          <ng-template let-item pTemplate="item">
            <div>
              {{ item.name }}
            </div>
          </ng-template>
        </p-multiSelect>

        <div class="invalid-message" *ngIf="
                  (businessType.touched || f.submitted) &&
                  businessType.errors?.required
                ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4" *ngIf="showOthername">
        <label>Specify</label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" [(ngModel)]="otherBusinessName"
          name="othername" placeholder="Specify business type" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">Incorporation Location</label>
        <p-dropdown [options]="listCountry" [(ngModel)]="company.incorporationLoc.countryCode" optionLabel="countryName"
          placeholder="Select" class="d-block" styleClass="bene-we-dropdown" optionValue="countryCode"
          name="addIncorporationLocation" #addIncorporationLocation="ngModel" [disabled]="disableFields" required>
        </p-dropdown>
        <div class="invalid-message" *ngIf="
              (addIncorporationLocation.touched || f.submitted) &&
              addIncorporationLocation.errors?.required
            ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>

      <div class="col-8 d-flex company-estd-date-year">
        <div class="estd-year-field">
          <label class="d-block" [ngClass]="{'required': !company.establishedDate}">Established Year</label>
          <input type="text" [disabled]="disableFields" class="im-input" name="establishedYear"
            [(ngModel)]="company.establishedYear" placeholder="Enter establishment year" #establishedYear="ngModel"
            maxlength="4" pattern="^[0-9]*$" [required]="!company.establishedDate" />
          <span class="invalid-message" *ngIf="(establishedYear.touched || f.submitted) &&
                    establishedYear.errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="establishedYear.errors?.pattern">
            {{ getGlobalErrorMessages("INVALID_NUMBER") }}
          </span>
        </div>
        <div class="estd-or-field pl-1 pr-1 pt-4 d-flex"><span>or</span></div>
        <div class="estd-date-field">
          <label class="d-block">Established Date</label>
          <p-calendar [disabled]="disableFields" showButtonBar="true" [(ngModel)]="company.establishedDate"
            [maxDate]="maxDate" [monthNavigator]="true" [yearNavigator]="true" name="establishedDate" class="w-100"
            yearRange="1910:2050" dateFormat="mm-dd-yy" [showIcon]="true" placeholder="Choose a date"></p-calendar>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">No. of Employees In U.S.</label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" name="incorporationLoc"
          [(ngModel)]="company.employeeCount" placeholder="Employee Count" #incorporationLoc="ngModel" required
          maxlength="9" pattern="^[0-9]*[1-9][0-9]*$" (ngModelChange)="handleEmployeeCountChange($event)" />
        <span class="invalid-message" *ngIf="
              (incorporationLoc.touched || f.submitted) &&
              incorporationLoc.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="incorporationLoc.errors?.pattern">
          {{ getGlobalErrorMessages("INVALID_NUMBER") }}
        </span>
      </div>
      <!-- <div class="col-4"> {{ companyDetailsForm.value.incorporationLoc }}
          <label >NAICS Code<span *ngIf="company.incorporationLoc.countryCode === 'USA'" class="text-danger">*</span></label>
        <input type="text" [disabled]="disableFields" class="im-input" name="naicsCode" [(ngModel)]="company.naicsCode" [required]="company.incorporationLoc.countryCode === 'USA'"
          placeholder="NAICS Code" #naicsCode="ngModel" maxlength="6" pattern="\d{6}" />
        <span class="invalid-message" *ngIf="
                (naicsCode.touched || f.submitted) && naicsCode.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="naicsCode.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "6" }}
        </span>
        <span class="invalid-message" *ngIf="naicsCode.errors?.pattern">
          {{ getGlobalErrorMessages("MINLENGTH") + "6 Numbers" }}
        </span>
        </div> -->
      <div class="col-4">
        {{ companyDetailsForm.value.incorporationLoc }}
        <label class="control-lbl">NAICS Code<span class="required"
            *ngIf="company.incorporationLoc.countryCode === 'USA'"></span></label>
        <div (appClickOutside)="clickedOutside()" class="multiselect-custom-holder" [class.disabled]="disableFields">
          <div class="multiselect-value-selected"
            (click)="showMultiselectList = !showMultiselectList; multiSelectClicked = true;" *ngIf="!disableFields">
            <span class="multiselect-value">{{ this.company.naicsCodeSelectedTitleArr &&
              this.company.naicsCodeSelectedTitleArr.length > 0 ? this.company.naicsCodeSelectedTitleArr.join(', ') :
              'Select' }}</span>
            <span class="pi pi-chevron-down"></span>
          </div>
          <div class="multiselect-value-selected" *ngIf="disableFields">
            <span class="multiselect-value">{{ this.company.naicsCodeSelectedTitleArr &&
              this.company.naicsCodeSelectedTitleArr.length > 0 ? this.company.naicsCodeSelectedTitleArr.join(', ') :
              'Select' }}</span>
            <span class="pi pi-chevron-down"></span>
          </div>
          <div class="multiselect-list-holder" *ngIf="showMultiselectList">
            <div class="multiselect-list-search-holder clearfix">
              <!-- <p-checkbox name="multiselect-list-check-all" class="multiselect-list-check-all"
                  [(ngModel)]="multiselectAllSelected" (onChange)="multiselectSelectAllClicked()"
                  [binary]="true"></p-checkbox> -->
              <input type="text" class="multiselect-list-search-text" pInputText [(ngModel)]="multiselectSearchValue"
                name="multiselectSearch" (keyup)="onFilterNaics()" (keydown)="onFilterNaics()" />
              <a class="multiselect-list-search-holder-close pi pi-times" (click)="clickedOutside()"></a>
            </div>
            <ul class="multiselect-list-ul" *ngIf="naicsList && naicsList.length > 0">
              <li class="multiselect-list-li cursor-pointer" [ngClass]="{'naics-selected': item.selected}"
                (click)="onNaicsSelect(item)" *ngFor="let item of naicsList; let i = index;">
                <a class="multiselect-list-checkbox-holder clearfix" [ngClass]="{'naics-disabled': item.disabled}">
                  <div *ngIf="item.disabled" class="disabled-overlay"></div>
                  <div class="naics-custom-checkbox"
                    [ngClass]="{'naics-checked': item.selected, 'naics-disabled': item.disabled}">
                    <span class="pi pi-check"></span>
                  </div>
                  <span class="multiselect-list-checkbox-text">{{ item.naicsTitle
                    }}</span>
                </a>
              </li>
            </ul>
            <ul class="multiselect-list-ul"
              *ngIf="(!naicsList || (naicsList && naicsList.length === 0)) && multiselectSearchValue && multiselectSearchValue.length >= 3">
              <li class=" multiselect-list-li">
                <a class="multiselect-list-checkbox-holder clearfix">
                  <span class="multiselect-list-checkbox-text-empty">No results found</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <mat-hint class="hint-text">Search with minimum 3 characters</mat-hint>
        <div class="invalid-message" *ngIf="
                      (multiSelectClicked || f.submitted) &&
                      (!company.naicsCodeNew || (company.naicsCodeNew && company.naicsCodeNew.length === 0))
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4">
        <label>FEI Number <span *ngIf="company.incorporationLoc.countryCode === 'USA'"
            class="text-danger">*</span></label>
        <!-- IM-3474 - FEI no- should  have 9 digits, NAICS code- should  have 6 digits and DOT code-should  have 3 digits-->
        <!-- IM-4285 - Platform Admin-Styling of FEIN in attorney and company are different and also while creating company, the country USA is default, the same behaviour to be followed to Attorney also.-->
        <input type="text" [disabled]="disableFields" class="im-input" name="feiNo" [(ngModel)]="company.feiNo"
          maxlength="10" minlength="9" placeholder="Enter FEI Number" #feiNo="ngModel"
          [required]="company.incorporationLoc.countryCode === 'USA'" pattern="^\d{2}\-?\d{7}$" />
        <span class="invalid-message" *ngIf="(feiNo.touched || f.submitted) && feiNo.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="feiNo.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "9" }}
        </span>
        <span class="invalid-message" *ngIf="feiNo.errors?.minlength">
          {{ getGlobalErrorMessages("MINLENGTH") + "9 Numbers" }}
        </span>
        <span class="invalid-message" *ngIf="(feiNo.touched || f.submitted) && feiNo.errors?.pattern">
          {{getGlobalErrorMessages('INVALID_FORMAT')}}
        </span>
        <small>00-0000000</small>
      </div>
      <div class="col-12 pl-0">
        <label class="control-lbl mr-2">Do you currently employ a total of 25 or fewer full-time equivalent employees in
          the United States, including all affiliates or subsidiaries of this company/organization?</label>
        <p-inputSwitch name="isTotalEmployeeMoreThanTwentyFive" [(ngModel)]="company.isTotalEmployeeMoreThanTwentyFive"
          class="absPositionSwitch">
        </p-inputSwitch>
      </div>

      <div class="form-group col-md-4 pl-0">
        <label class="label-cls">Domain Name</label>
        <input disabled type="text" class="im-input" name="domainName" [(ngModel)]="company.domainName"
          value="imagility.co" [disabled]="clientViewMode || !isPlatformAdmin" placeholder="Enter Domain Name"
          #domainName="ngModel" />
        <mat-hint class="hint-text">If you want to create white label company please contact IMAGILITY TEAM</mat-hint>
      </div>

    </div>
    <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
    <div class="row" class="font-weight-bold mb-4">
      Contact Details
    </div>
    <div class="row">
      <div class="col-4 pl-0"><label class="required">Office Telephone Number</label></div>
      <div class="col-4"><label class="required">Mobile Number</label></div>
    </div>
    <div class="row">
      <div class="col-1 pl-0 pr-0">
        <p-dropdown [options]="listCountry" [(ngModel)]="company.phoneContact.countryCode"
          optionLabel="countryPhoneCode" placeholder="Select" class="d-block" optionValue="countryCode" name="phoneCode"
          #phoneCode="ngModel" [disabled]="disableFields" required>
        </p-dropdown>
        <div class="invalid-message" *ngIf="
                (phoneNo.touched || phoneCode.touched || f.submitted) && phoneCode.errors?.required
              ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-3 pl-0">
        <input pInputText class="im-input" [disabled]="disableFields" name="phoneNo" maxlength="10"
          [(ngModel)]="company.phoneContact.phoneNo" type="text" form placeholder="Office" #phoneNo="ngModel" required
          pattern="\d{1,10}"
          [ngClass]="{'im-input-error':(phoneCode.touched || phoneNo.touched || f.submitted) && phoneNo.errors?.required}" />
        <span class="invalid-message" *ngIf="
                (phoneNo.touched || f.submitted) && phoneNo.errors?.pattern
              ">
          {{ getGlobalErrorMessages("INVALID_NUMBER") }}
        </span>
        <span class="invalid-message" *ngIf="phoneNo.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
        </span>
      </div>
      <div class="col-1 pr-0">
        <p-dropdown [options]="listCountry" [(ngModel)]="company.mobileContact.countryCode"
          optionLabel="countryPhoneCode" placeholder="Select" class="d-block" styleClass="bene-we-dropdown"
          optionValue="countryCode" name="altMobileCode" #altMobileCode="ngModel" [disabled]="disableFields" required>
        </p-dropdown>
        <div class="invalid-message" *ngIf="
                (altMobile.touched || altMobileCode.touched || f.submitted) && altMobileCode.errors?.required
              ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>

      </div>
      <div class="col-3  pl-0">
        <input pInputText class="im-input" [disabled]="disableFields" name="altMobile" maxlength="10"
          [(ngModel)]="company.mobileContact.phoneNo" type="text" form placeholder="Mobile" #altMobile="ngModel"
          pattern="\d{1,10}" required
          [ngClass]="{'im-input-error':(altMobile.touched || altMobileCode.touched || f.submitted) && altMobile.errors?.required}" />
        <span class="invalid-message" *ngIf="
                        (altMobile.touched || f.submitted) && altMobile.errors?.pattern
                      ">
          {{ getGlobalErrorMessages("INVALID_NUMBER") }}
        </span>
        <span class="invalid-message" *ngIf="altMobile.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">Email for USCIS communication</label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" email name="email"
          [(ngModel)]="company.emailContact.email" placeholder="Email" #email="ngModel" required
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$" />
        <span class="invalid-message" *ngIf="(email.touched || f.submitted) && email.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <div class="invalid-message" *ngIf="(email.touched || f.submitted) && email.errors?.pattern">
          {{ getGlobalErrorMessages("INVALID_EMAIL") }}
        </div>
      </div>
      <div class="col-4">
        <label class="">Email for Beneficiary/Lawfirm Communication <i
            pTooltip="Provide Email id for beneficary to communicate" class="pi pi-info-circle"></i></label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" email name="altEmail"
          [(ngModel)]="company.altEmailContact.email" placeholder="Alternate Email" #altEmail="ngModel"
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$" />
        <div class="invalid-message" *ngIf="(altEmail.touched || f.submitted) && altEmail.errors?.pattern">
          {{ getGlobalErrorMessages("INVALID_EMAIL") }}
        </div>
      </div>
    </div>

    <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
    <div class="row" class="font-weight-bold mb-4">
      Registered Address
    </div>
    <div class="row mt-4">
      <div class="col-6 pl-0">
        <label class="required">Address 1</label><small class="text-secondary pl-1">Ex: Street Name & Number</small>
        <input pInputText class="im-input" [disabled]="disableFields" name="addressLine"
          [(ngModel)]="company.address[0].addressLine1" type="text" placeholder="Enter" #addressLine="ngModel"
          required />
        <span class="invalid-message" *ngIf="
                    (addressLine.touched || f.submitted) && addressLine.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-6 pl-0">
        <label>Address 2</label><small class="text-secondary pl-1">Optional</small><i
          pTooltip='Enter Apartment, Suite, Floor number with the prefix Apt, Ste or Flr respectively. This will be automatically mapped to the Apartment, Suite and Floor fields in the forms'
          class="pi pi-info-circle pl-1"></i>
        <input pInputText class="im-input" [disabled]="disableFields" name="addressLines"
          [(ngModel)]="company.address[0].addressLine2" type="text" placeholder="Enter" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">Country</label>
        <!--<mat-form-field>-->
        <p-dropdown [options]="listCountry" [(ngModel)]="company.address[0].countryCode" optionLabel="countryName"
          placeholder="Select" class="d-block" styleClass="bene-we-dropdown" optionValue="countryCode" name="addCountry"
          (onChange)="handleCountryChange(company.address[0].countryCode, 'reg')" #addCountry="ngModel"
          [disabled]="disableFields" required></p-dropdown>

        <!--</mat-form-field>-->
        <div class="invalid-message" *ngIf="
                      (addCountry.touched || f.submitted) && addCountry.errors?.required
                    ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4" *ngIf="listStates.length > 0">
        <label class="required">State</label>
        <!--<mat-form-field>-->
        <p-dropdown [options]="listStates" [(ngModel)]="company.address[0].stateProvinceCode"
          optionLabel="stateProvinceName" placeholder="Select" class="d-block" styleClass="bene-we-dropdown"
          optionValue="stateProvinceCode" name="addState" #addState="ngModel" [disabled]="disableFields" required>
        </p-dropdown>
        <!--</mat-form-field>-->
        <div class="invalid-message" *ngIf="
                      (addState.touched || f.submitted) && addState.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4" *ngIf="listStates.length <= 0">
        <label>State*</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrState"
          [(ngModel)]="company.address[0].stateProvinceName" type="text" placeholder="State" #addrState="ngModel"
          required />
        <span class="invalid-message" *ngIf="
                      (addrState.touched || f.submitted) && addrState.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>

    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">City</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrCity"
          [(ngModel)]="company.address[0].city" type="text" placeholder="City" #addrCity="ngModel" required />
        <span class="invalid-message" *ngIf="(addrCity.touched || f.submitted) && addrCity.errors?.required ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4">
        <label class="required">Zip Code</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrPostCode"
          [(ngModel)]="company.address[0].postCode" type="text" placeholder="Zip Code" #addrPostCode="ngModel" required
          pattern="^$|^[A-Za-z0-9]+" maxlength="10" />
        <span class="invalid-message" *ngIf="(addrPostCode.touched || f.submitted) &&
                  addrPostCode.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="(addrPostCode.touched || f.submitted) &&
                      addrPostCode.errors?.pattern">
          {{ getGlobalErrorMessages("ZIPCODE_ONLY") }}
        </span>
        <span class="invalid-message" *ngIf="addrPostCode.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
        </span>
      </div>
    </div>
    <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
    <div class="row" class="font-weight-bold mb-4">
      Mailing Address
    </div>
    <div class="col-8 pl-0">
      <p-checkbox name="isSameAddress" label="Same as Registered Address" [disabled]="disableFields"
        (onChange)="copyAddress($event)" [(ngModel)]="isSameAddress" [binary]="true">

      </p-checkbox>
    </div>
    <div class="row mt-4">
      <div class="col-6 pl-0">
        <label class="required">Address 1</label><small class="text-secondary pl-1">Ex: Street Name & Number</small>
        <input pInputText class="im-input" [disabled]="disableFields" name="addressLineMail"
          [(ngModel)]="company.address[1].addressLine1" type="text" placeholder="Enter" #addressLineMail="ngModel"
          required />
        <span class="invalid-message" *ngIf="
                    (addressLineMail.touched || f.submitted) &&
                    addressLineMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-6 pl-0">
        <label>Address 2</label><small class="text-secondary pl-1">Optional</small><i
          pTooltip='Enter Apartment, Suite, Floor number with the prefix Apt, Ste or Flr respectively. This will be automatically mapped to the Apartment, Suite and Floor fields in the forms'
          class="pi pi-info-circle pl-1"></i>
        <input pInputText class="im-input" [disabled]="disableFields" name="addressLinesMail"
          [(ngModel)]="company.address[1].addressLine2" type="text" placeholder="Enter" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="form-group col-4 pl-0">
        <label class="required">Country</label>
        <p-dropdown [options]="listCountry" [(ngModel)]="company.address[1].countryCode" optionLabel="countryName"
          placeholder="Select" class="d-block" styleClass="bene-we-dropdown" optionValue="countryCode"
          name="addCountryMail" (onChange)="handleCountryChange(company.address[1].countryCode, 'mail')"
          #addCountryMail="ngModel" [disabled]="disableFields" required></p-dropdown>
        <div class="invalid-message" *ngIf="
                    (addCountryMail.touched || f.submitted) &&
                    addCountryMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4" *ngIf="listStatesMail.length > 0">
        <label class="required">State</label>
        <p-dropdown [options]="listStatesMail" [(ngModel)]="company.address[1].stateProvinceCode"
          optionLabel="stateProvinceName" placeholder="Select" class="d-block" styleClass="bene-we-dropdown"
          optionValue="stateProvinceCode" name="addStateMail" #addStateMail="ngModel" [disabled]="disableFields"
          required></p-dropdown>
        <div class="invalid-message" *ngIf="
                    (addStateMail.touched || f.submitted) &&
                    addStateMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </div>
      </div>
      <div class="col-4" *ngIf="listStatesMail.length <= 0">
        <label class="required">State</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrStateMail"
          [(ngModel)]="company.address[1].stateProvinceName" type="text" placeholder="State" #addrStateMail="ngModel"
          required />
        <span class="invalid-message" *ngIf="
                    (addrStateMail.touched || f.submitted) &&
                    addrStateMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-4 pl-0">
        <label class="required">City</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrCityMail"
          [(ngModel)]="company.address[1].city" type="text" placeholder="City" #addrCityMail="ngModel" required />
        <span class="invalid-message" *ngIf="
                    (addrCityMail.touched || f.submitted) &&
                    addrCityMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
      </div>
      <div class="col-4">
        <label class="required">Zip Code</label>
        <input pInputText class="im-input" [disabled]="disableFields" name="addrPostCodeMail"
          [(ngModel)]="company.address[1].postCode" type="text" placeholder="Zip Code" #addrPostCodeMail="ngModel"
          required pattern="^$|^[A-Za-z0-9]+" maxlength="10" />
        <span class="invalid-message" *ngIf="
                    (addrPostCodeMail.touched || f.submitted) &&
                    addrPostCodeMail.errors?.required
                  ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="
                    (addrPostCodeMail.touched || f.submitted) &&
                    addrPostCodeMail.errors?.pattern
                  ">
          {{ getGlobalErrorMessages("INVALID_NUMBER") }}
        </span>
        <span class="invalid-message" *ngIf="addrPostCodeMail.errors?.maxlength">
          {{ getGlobalErrorMessages("MAXLENGTH") + "7" }}
        </span>
      </div>
    </div>
    <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
    <div class="row" class="font-weight-bold mb-4">
      Revenue Details
    </div>
    <div class="row mt-2">
      <div class="col-4 pl-0">
        <label class="required">Gross Annual Income</label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" name="annual"
          [(ngModel)]="company.grossAnnualIncome" placeholder="Gross Annual Income" #annual="ngModel" [required]="!isProprietary ? true : null" [readonly]="isProprietary ? true : null" />
        <span class="invalid-message" *ngIf="(annual.touched || f.submitted) && annual.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <!-- <span class="invalid-message" *ngIf="(annual.touched || f.submitted) && annual.errors?.pattern">
              {{ getGlobalErrorMessages("INVALID_NUMBER") }}
            </span> -->
      </div>
      <div class="col-4">
        <label class="required">Net Annual Income</label>
        <input pInputText type="text" [disabled]="disableFields" class="im-input" name="gross"
          [(ngModel)]="company.netAnnualIncome" placeholder="Net Annual Income" #gross="ngModel" [required]="!isProprietary ? true : null" [readonly]="isProprietary ? true : null" />
        <span class="invalid-message" *ngIf="(gross.touched || f.submitted) && gross.errors?.required">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <!-- <span class="invalid-message" *ngIf="(gross.touched || f.submitted) && gross.errors?.pattern">
              {{ getGlobalErrorMessages("INVALID_NUMBER") }}
            </span> -->
      </div>
      <div class="col-4 mt-4 pt-3">
        <mat-checkbox name="isProprietary" [disabled]="clientViewMode" (change)="onProprietaryCheckboxChanged($event)"
        [(ngModel)]="isProprietary">
        <span>Proprietary</span>
      </mat-checkbox>
        
        </div>
      <div class="col-12 pl-0 mt-3">
        <label class="control-lbl mr-2">Are you a nonprofit organized as tax exempt or a governmental research
          organization?</label>
        <p-inputSwitch name="isNonProfitTaxExemptOrg" [(ngModel)]="company.isNonProfitTaxExemptOrg"
          class="absPositionSwitch">
        </p-inputSwitch>
      </div>
    </div>
    <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
    <div class="row">
      <div class="col-6"></div>
      <div class="col text-right">
        <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
          Cancel
        </button>

        <div class="border-right d-inline-block mr-4" style="height:46px"></div>
        <lib-save-as-draft confirmModelKey="savedraftclient" styleClass="im-btn im-btn-primary btn-primary mr-2"
          [disabled]="isSaveAsDraftDisabled" (onClickSaveAsDraft)="saveAsDraft($event)"
          [formToBeSaved]="f"></lib-save-as-draft>
        <button type="submit" class="im-btn im-btn-primary im-btn-md mr-2" [disabled]="f.invalid||disableFields">
          Save
        </button>
        <button type="button" [disabled]="this.disabledNextBtn" (click)="onNext()"
          class="im-btn im-btn-primary im-btn-md">
          Next
        </button>

      </div>
    </div>
  </form>
</div>